(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page-policy"]) return;
  try {
    
(function () {
  var tocList = document.querySelector('.zaviqu-policy__toc-list');
  if (!tocList || tocList.children.length > 0) return;

  var headings = document.querySelectorAll('.policy-content--flat h2');
  var toc = document.querySelector('.zaviqu-policy__toc');
  if (!headings.length) {
    if (toc) toc.style.display = 'none';
    return;
  }

  var used = {};
  headings.forEach(function (heading) {
    var slug = heading.id;
    if (!slug) {
      slug = heading.textContent
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-+|-+$)/g, '');
      if (!slug) slug = 'section';
      var base = slug;
      var i = 1;
      while (used[slug]) {
        slug = base + '-' + i;
        i += 1;
      }
      heading.id = slug;
    }
    used[slug] = true;

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + slug;
    a.textContent = heading.textContent;
    li.appendChild(a);
    tocList.appendChild(li);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zaviqu-gift-preview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
const CHECKOUT_CONFIG = {
  // USD pricing, flat regardless of finish. The Classic Box is included in
  // the base price; the Signature Box is a fixed-dollar upgrade on top of
  // it — never a separate full price. Mirrors the real fixed USD price list
  // on the US market: every necklace variant is priced at basePrice (Classic)
  // or basePrice + boxUpgrade.wood (Signature).
  basePrice: 69.99,
  boxUpgrade: {
    white: 0,
    wood: 20.00,
  },
  messageCharLimit: 200,
  messageMinLength: 20,
};

// Each card design is its own Shopify product / ShineOn template. This map routes
// (cardDesign, finish, box) to the exact variant ID for that design, so checkout
// always adds the product that matches what the customer actually selected.
// Re-synced against live Shopify variant IDs — the previous IDs here were stale
// (didn't resolve to any real variant), so checkout could not succeed for any
// selection. gold = 18K Yellow Gold Finish, silver = 14K White Gold Finish,
// white = Classic Box, wood = Signature Box.
const CARD_DESIGN_VARIANT_ID = {
  'midnight-luxe': {
    gold: { white: '70974971478269', wood: '70974971511037' },
    silver: { white: '70974971412733', wood: '70974971445501' },
  },
  'ivory-elegance': {
    gold: { white: '70974947229949', wood: '70974947262717' },
    silver: { white: '70974947164413', wood: '70974947197181' },
  },
  'romantic-blush': {
    gold: { white: '70974973378813', wood: '70974973411581' },
    silver: { white: '70974973313277', wood: '70974973346045' },
  },
  'vintage-linen': {
    gold: { white: '70974977966333', wood: '70974977999101' },
    silver: { white: '70974977900797', wood: '70974977933565' },
  },
};

const BOX_OPTIONS = {
  white: { label: 'Classic Box' },
  wood: { label: 'Signature Box' },
};

// Curated design set shown to customers. Each `templateId` should be filled in with
// the real supported template ID once personalisation is connected.
// image/bg/textColor are applied directly via JS (not left to CSS attribute selectors alone)
// so the live preview is guaranteed to update for every design, not just the default.
const CARD_DESIGNS = [
  { id: 'midnight-luxe', name: 'Midnight Luxe', templateId: null, image: window.zaviquCardImages['midnight-luxe'], bg: '#0e0d0d', textColor: '#f3efe6' },
  { id: 'ivory-elegance', name: 'Ivory Elegance', templateId: null, image: window.zaviquCardImages['ivory-elegance'], bg: '#efddbd', textColor: '#2a2620' },
  { id: 'romantic-blush', name: 'Romantic Blush', templateId: null, image: window.zaviquCardImages['romantic-blush'], bg: '#fad8ce', textColor: '#3a2129' },
  { id: 'vintage-linen', name: 'Vintage Linen', templateId: null, image: window.zaviquCardImages['vintage-linen'], bg: '#fdf6eb', textColor: '#2a2620' },
];

function applyCardVisual(el, design) {
  if (!el || !design) return;
  el.style.backgroundImage = `url('${design.image}')`;
  el.style.backgroundColor = design.bg;
}

const HERO_IMAGES = {
  gold: { wood: window.zaviquGiftBoxImages.woodGold, white: window.zaviquGiftBoxImages.whiteGold },
  silver: { wood: window.zaviquGiftBoxImages.woodSilver, white: window.zaviquGiftBoxImages.whiteSilver },
};

// Warms the browser cache for the 4 hero combinations and 4 card templates
// as soon as the page loads, so switching Finish, Gift Box or Card Design
// never has to wait on a network fetch.
function preloadGiftPreviewImages() {
  Object.values(HERO_IMAGES).forEach((byBox) => {
    Object.values(byBox).forEach((url) => {
      const preloadImg = new Image();
      preloadImg.src = url;
    });
  });
  Object.values(window.zaviquCardImages || {}).forEach((url) => {
    const preloadImg = new Image();
    preloadImg.src = url;
  });
}

function formatMoney(amount) {
  return '$' + amount.toFixed(2);
}

// Computes the "ideal" scale for the message purely from how long the
// customer's written message is, independent of whether it currently fits
// any particular box: short messages read noticeably larger, medium-length
// messages sit at the normal (1x) size, and long messages taper smoothly
// down toward the same floor the fit algorithm below enforces as a hard
// minimum. This is only a starting point — fitMessageBlock still shrinks
// further from here if the actual rendered content (including "To", the
// sign-off, and manual line breaks) doesn't fit.
const MESSAGE_MIN_SCALE = 0.6;
const MESSAGE_SCALE_STEP = 0.03;
const SHORT_MESSAGE_MAX_LENGTH = 50;
const LONG_MESSAGE_START_LENGTH = 120;
const LONG_MESSAGE_MAX_LENGTH = 200;
const SHORT_MESSAGE_SCALE = 1.35;
const NORMAL_MESSAGE_SCALE = 1;

function getTargetScale(bodyLength) {
  if (bodyLength <= SHORT_MESSAGE_MAX_LENGTH) {
    const progress = bodyLength / SHORT_MESSAGE_MAX_LENGTH;
    return SHORT_MESSAGE_SCALE - progress * (SHORT_MESSAGE_SCALE - NORMAL_MESSAGE_SCALE);
  }
  if (bodyLength <= LONG_MESSAGE_START_LENGTH) {
    return NORMAL_MESSAGE_SCALE;
  }
  const range = LONG_MESSAGE_MAX_LENGTH - LONG_MESSAGE_START_LENGTH;
  const progress = Math.min((bodyLength - LONG_MESSAGE_START_LENGTH) / range, 1);
  return NORMAL_MESSAGE_SCALE - progress * (NORMAL_MESSAGE_SCALE - MESSAGE_MIN_SCALE);
}

// Shrinks the message block to fit the fixed safe writing area, starting
// from the length-based target scale above and measuring the actual
// rendered height of the current combined content. Never shrinks past
// MESSAGE_MIN_SCALE — callers surface a warning instead of continuing to
// shrink when even the floor size still overflows.
function fitMessageBlock(outerEl, innerEl, startScale) {
  if (!outerEl || !innerEl) return { fits: true, scale: 1 };
  let scale = startScale;
  outerEl.style.setProperty('--gp-message-scale', String(scale));
  let fits = innerEl.scrollHeight <= outerEl.clientHeight + 1;
  while (!fits && scale > MESSAGE_MIN_SCALE) {
    scale = Math.max(MESSAGE_MIN_SCALE, Number((scale - MESSAGE_SCALE_STEP).toFixed(2)));
    outerEl.style.setProperty('--gp-message-scale', String(scale));
    fits = innerEl.scrollHeight <= outerEl.clientHeight + 1;
  }
  return { fits, scale };
}

// Sets the message sections' (plus placeholder) text and visibility on a
// given set of target elements. `targets` and `message` share the same
// shape: { to, body, signoff } — `targets` also carries `root`, `inner`, and
// `placeholder`. Empty optional sections are hidden entirely via the
// `hidden` attribute so they collapse out of the flex layout, leaving no
// blank space. Pure content — no fit/scale here.
// Capitalizes the recipient line for display/print without touching how the
// customer typed the rest of their message. Fixes the first letter of the
// line itself, and — when the line reads as "to <name>" in any casing —
// also fixes the first letter of the name right after it, so "to roda" and
// "TO roda" both render as "To Roda". Anything beyond that (the rest of the
// line, and the body/sign-off fields entirely) is left exactly as written.
function formatRecipientLine(rawTo) {
  const trimmed = rawTo.trim();
  if (!trimmed) return trimmed;
  let result = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  const toPrefix = result.match(/^(to\s+)(\S)/i);
  if (toPrefix) {
    const leadLength = toPrefix[1].length;
    result =
      result.slice(0, leadLength).replace(/^to/i, 'To') +
      result.charAt(leadLength).toUpperCase() +
      result.slice(leadLength + 1);
  }
  return result;
}

function setSectionContent(targets, message) {
  const to = formatRecipientLine(message.to);
  const body = message.body.trim();
  const signoff = message.signoff.trim();
  const hasAny = Boolean(to || body || signoff);

  if (targets.placeholder) targets.placeholder.hidden = hasAny;
  if (targets.to) {
    targets.to.hidden = !to;
    targets.to.textContent = to;
  }
  if (targets.body) {
    targets.body.hidden = !body;
    targets.body.textContent = body;
  }
  if (targets.signoff) {
    targets.signoff.hidden = !signoff;
    targets.signoff.textContent = signoff;
  }
}

// Computes the single canonical fit/scale decision for a given message by
// rendering it into the off-screen probe (sized like the large card-view
// modal). This is the one source of truth for "does this message fit the
// card at a readable size" — the small thumbnail preview never decides this
// on its own, since its cramped pixel budget doesn't represent the real card.
// Renders a message into a visible target (thumbnail or card-view modal)
// using an already-computed canonical scale, so every visible rendering of
// the message stays consistent with the one canonical fit decision.
function applyMessageRender(targets, message, scale) {
  setSectionContent(targets, message);
  if (targets.root) targets.root.style.setProperty('--gp-message-scale', String(scale));
}

// Combines the three sections into the single "Personal Message" line-item
// property, in card order, so the existing ShineOn/checkout property mapping
// (unchanged) still receives one coherent block of text.
function composePersonalMessage(message) {
  return [formatRecipientLine(message.to), message.body.trim(), message.signoff.trim()]
    .filter(Boolean)
    .join('\n\n');
}

function normalizeStoredMessage(rawMessage) {
  if (rawMessage && typeof rawMessage === 'object') {
    return {
      to: typeof rawMessage.to === 'string' ? rawMessage.to : '',
      body: typeof rawMessage.body === 'string' ? rawMessage.body : '',
      signoff: typeof rawMessage.signoff === 'string' ? rawMessage.signoff : '',
    };
  }
  if (typeof rawMessage === 'string') {
    // Legacy single-field format from before the multi-section redesign.
    return { to: '', body: rawMessage, signoff: '' };
  }
  return { to: '', body: '', signoff: '' };
}

const giftPreviewMain = document.querySelector('.gift-preview');

if (giftPreviewMain) {
  preloadGiftPreviewImages();

  const gpNotice = document.getElementById('gpNotice');
  const gpHeroPhotoA = document.getElementById('gpHeroPhotoA');
  const gpHeroPhotoB = document.getElementById('gpHeroPhotoB');
  const gpCardPreviewInner = document.getElementById('gpCardPreviewInner');
  const gpMessageText = document.getElementById('gpMessageText');
  const gpMessageSummaryText = document.getElementById('gpMessageSummaryText');

  const gpFinishLabel = document.getElementById('gpFinishLabel');
  const gpItemPrice = document.getElementById('gpItemPrice');
  const gpBoxLabel = document.getElementById('gpBoxLabel');
  const gpBoxValue = document.getElementById('gpBoxValue');
  const gpCardDesignValue = document.getElementById('gpCardDesignValue');
  const gpTotal = document.getElementById('gpTotal');
  const gpStickyTotal = document.getElementById('gpStickyTotal');

  const finishOptions = Array.from(document.querySelectorAll('.gp-pill[data-finish]'));
  const cardOptions = Array.from(document.querySelectorAll('.gp-pill[data-design]'));
  const boxOptions = Array.from(document.querySelectorAll('.gp-pill[data-tier]'));
  const checkoutButtons = [document.getElementById('checkoutBtn'), document.getElementById('checkoutBtnSticky')].filter(Boolean);

  const cardPreviewName = document.getElementById('cardPreviewName');
  const viewCardDesignsBtn = document.getElementById('viewCardDesignsBtn');

  const cardModal = document.getElementById('cardModal');
  const cardModalBackdrop = document.getElementById('cardModalBackdrop');
  const cardModalClose = document.getElementById('cardModalClose');
  const cardModalCard = document.getElementById('cardModalCard');
  const cardModalMessage = document.getElementById('cardModalMessage');
  const cardModalName = document.getElementById('cardModalName');
  const cardModalPrevBtn = document.getElementById('cardModalPrevBtn');
  const cardModalNextBtn = document.getElementById('cardModalNextBtn');
  const cardModalDots = Array.from(document.querySelectorAll('.gp-card-modal__dot'));
  const cardModalSelectBtn = document.getElementById('cardModalSelectBtn');

  const editMessageBtn = document.getElementById('editMessageBtn');
  const messageModal = document.getElementById('messageModal');
  const messageModalBackdrop = document.getElementById('messageModalBackdrop');
  const messageModalCancel = document.getElementById('messageModalCancel');
  const messageModalSave = document.getElementById('messageModalSave');
  const messageModalOverflowWarning = document.getElementById('messageModalOverflowWarning');

  const msgFields = {
    to: {
      el: document.getElementById('msgToInput'),
      counter: document.getElementById('msgToCounter'),
    },
    body: {
      el: document.getElementById('msgBodyInput'),
      counter: document.getElementById('msgBodyCounter'),
      warning: document.getElementById('msgBodyWarning'),
    },
    signoff: {
      el: document.getElementById('msgSignoffInput'),
      counter: document.getElementById('msgSignoffCounter'),
    },
  };
  Object.values(msgFields).forEach((field) => {
    field.max = field.el ? Number(field.el.getAttribute('maxlength')) : 0;
  });

  const gpMessageTargets = {
    root: gpMessageText,
    inner: document.getElementById('gpMessageInner'),
    placeholder: document.getElementById('gpMsgPlaceholder'),
    to: document.getElementById('gpMsgTo'),
    body: document.getElementById('gpMsgBody'),
    signoff: document.getElementById('gpMsgSignoff'),
  };

  const cardModalMessageTargets = {
    root: cardModalMessage,
    inner: document.getElementById('cardModalMessageInner'),
    placeholder: document.getElementById('cardModalMsgPlaceholder'),
    to: document.getElementById('cardModalMsgTo'),
    body: document.getElementById('cardModalMsgBody'),
    signoff: document.getElementById('cardModalMsgSignoff'),
  };

  const fitProbeTargets = {
    root: document.getElementById('gpFitProbeOuter'),
    inner: document.getElementById('gpFitProbeInner'),
    placeholder: null,
    to: document.getElementById('gpFitProbeTo'),
    body: document.getElementById('gpFitProbeBody'),
    signoff: document.getElementById('gpFitProbeSignoff'),
  };

  function computeCanonicalFit(message) {
    setSectionContent(fitProbeTargets, message);
    const startScale = getTargetScale(message.body.trim().length);
    return fitMessageBlock(fitProbeTargets.root, fitProbeTargets.inner, startScale);
  }

  let lastMessageFits = true;

  let hadStoredConfig = false;
  let stored = {};
  try {
    const raw = sessionStorage.getItem('zaviquGiftConfig');
    if (raw) {
      hadStoredConfig = true;
      stored = JSON.parse(raw);
    }
  } catch (e) {
    // Malformed config — fall back to defaults below and still show the notice.
  }

  const state = {
    finish: stored.finish === 'silver' ? 'silver' : 'gold',
    message: normalizeStoredMessage(stored.message),
    cardDesign: CARD_DESIGNS.some((d) => d.id === stored.cardDesign) ? stored.cardDesign : 'midnight-luxe',
    box: stored.box === 'wood' ? 'wood' : 'white',
  };

  if (!hadStoredConfig && gpNotice) {
    gpNotice.hidden = false;
  }

  function persist() {
    sessionStorage.setItem('zaviquGiftConfig', JSON.stringify(state));
  }

  function selectInGroup(options, target) {
    options.forEach((option) => {
      const isMatch = option === target;
      option.classList.toggle('is-selected', isMatch);
      option.setAttribute('aria-checked', String(isMatch));
      option.tabIndex = isMatch ? 0 : -1;
    });
  }

  function wireRadioGroup(options, onSelect) {
    options.forEach((option) => {
      option.addEventListener('click', () => onSelect(option));

      option.addEventListener('keydown', (event) => {
        const currentIndex = options.indexOf(option);
        let targetIndex = null;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = Math.min(currentIndex + 1, options.length - 1);
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = Math.max(currentIndex - 1, 0);
        else if (event.key === 'Home') targetIndex = 0;
        else if (event.key === 'End') targetIndex = options.length - 1;

        if (targetIndex !== null && targetIndex !== currentIndex) {
          event.preventDefault();
          const target = options[targetIndex];
          onSelect(target);
          target.focus();
        }
      });
    });
  }

  let activeHeroLayer = 'a';

  function renderHeroImage() {
    if (!gpHeroPhotoA || !gpHeroPhotoB) return;

    const url = HERO_IMAGES[state.finish][state.box];
    const activeEl = activeHeroLayer === 'a' ? gpHeroPhotoA : gpHeroPhotoB;
    const nextEl = activeHeroLayer === 'a' ? gpHeroPhotoB : gpHeroPhotoA;

    if (activeEl.dataset.url === url) return;

    // The image has already been preloaded (see preloadGiftPreviewImages), so
    // this resolves from cache almost immediately — but we still gate the
    // swap on the load event itself rather than assuming it's ready, so the
    // current photo never disappears before the replacement can take its
    // place.
    const preloadImg = new Image();
    preloadImg.onload = () => {
      nextEl.style.backgroundImage = `url('${url}')`;
      nextEl.dataset.url = url;
      nextEl.style.zIndex = '2';
      activeEl.style.zIndex = '1';
      nextEl.classList.add('is-active');
      activeEl.classList.remove('is-active');
      activeHeroLayer = activeHeroLayer === 'a' ? 'b' : 'a';
    };
    preloadImg.src = url;
  }

  function isBodyLongEnough(text) {
    return text.trim().length >= CHECKOUT_CONFIG.messageMinLength;
  }

  function updateCheckoutAvailability() {
    const valid = isBodyLongEnough(state.message.body) && lastMessageFits;
    checkoutButtons.forEach((button) => { button.disabled = !valid; });
  }

  function renderMessage() {
    const result = computeCanonicalFit(state.message);
    lastMessageFits = result.fits;
    applyMessageRender(gpMessageTargets, state.message, result.scale);
    if (gpMessageSummaryText) {
      const summary = composePersonalMessage(state.message);
      gpMessageSummaryText.textContent = summary || 'No message added yet.';
    }
    updateCheckoutAvailability();
  }

  function renderFinish() {
    const match = finishOptions.find((option) => option.dataset.finish === state.finish);
    if (match) selectInGroup(finishOptions, match);
    renderHeroImage();
  }

  function renderCardDesign() {
    const design = CARD_DESIGNS.find((d) => d.id === state.cardDesign) || CARD_DESIGNS[0];

    if (gpCardPreviewInner) {
      gpCardPreviewInner.dataset.design = design.id;
      applyCardVisual(gpCardPreviewInner, design);
    }
    if (gpMessageText) gpMessageText.style.color = design.textColor;
    if (cardPreviewName) cardPreviewName.textContent = design.name;

    const match = cardOptions.find((option) => option.dataset.design === design.id);
    if (match) selectInGroup(cardOptions, match);
  }

  function getAdjacentDesignId(currentId, delta) {
    const currentIndex = CARD_DESIGNS.findIndex((d) => d.id === currentId);
    const nextIndex = (currentIndex + delta + CARD_DESIGNS.length) % CARD_DESIGNS.length;
    return CARD_DESIGNS[nextIndex].id;
  }

  function renderBox() {
    const match = boxOptions.find((option) => option.dataset.tier === state.box);
    if (match) selectInGroup(boxOptions, match);
    renderHeroImage();
    renderPricing();
  }

  function renderPricing() {
    // Price depends only on the selected gift box — never on finish, so
    // switching Gold/Silver can never change the displayed or charged price.
    const upgrade = CHECKOUT_CONFIG.boxUpgrade[state.box];
    const total = CHECKOUT_CONFIG.basePrice + upgrade;
    const totalFormatted = formatMoney(total);
    const finishLabel = state.finish === 'silver' ? 'White Gold Finish Necklace' : 'Gold Necklace';
    const boxLabel = BOX_OPTIONS[state.box].label;
    const design = CARD_DESIGNS.find((d) => d.id === state.cardDesign) || CARD_DESIGNS[0];

    if (gpFinishLabel) gpFinishLabel.textContent = finishLabel;
    if (gpItemPrice) gpItemPrice.textContent = formatMoney(CHECKOUT_CONFIG.basePrice);
    if (gpBoxLabel) gpBoxLabel.textContent = upgrade > 0 ? boxLabel + ' Upgrade' : boxLabel;
    if (gpBoxValue) gpBoxValue.textContent = upgrade > 0 ? '+' + formatMoney(upgrade) : 'Included';
    if (gpCardDesignValue) gpCardDesignValue.textContent = design.name;
    if (gpTotal) gpTotal.textContent = totalFormatted;
    if (gpStickyTotal) gpStickyTotal.textContent = totalFormatted;
  }

  renderFinish();
  renderMessage();
  renderCardDesign();
  renderBox();
  renderPricing();
  persist();

  wireRadioGroup(finishOptions, (target) => {
    state.finish = target.dataset.finish === 'silver' ? 'silver' : 'gold';
    renderFinish();
    renderPricing();
    persist();
  });

  wireRadioGroup(cardOptions, (target) => {
    state.cardDesign = target.dataset.design;
    renderCardDesign();
    renderPricing();
    persist();
  });

  wireRadioGroup(boxOptions, (target) => {
    state.box = target.dataset.tier === 'white' ? 'white' : 'wood';
    renderBox();
    persist();
  });

  if (gpCardPreviewInner) {
    gpCardPreviewInner.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openCardModal(gpCardPreviewInner); }
    });

    gpCardPreviewInner.addEventListener('click', () => openCardModal(gpCardPreviewInner));
  }

  let modalCardDesign = state.cardDesign;
  let cardModalTrigger = null;

  function renderCardModalView(designId) {
    const design = CARD_DESIGNS.find((d) => d.id === designId) || CARD_DESIGNS[0];

    if (cardModalCard) {
      cardModalCard.dataset.design = design.id;
      applyCardVisual(cardModalCard, design);
    }
    if (cardModalName) cardModalName.textContent = design.name;

    cardModalDots.forEach((dot) => {
      const isActive = dot.dataset.design === design.id;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', String(isActive));
    });

    if (cardModalMessage) {
      cardModalMessage.style.color = design.textColor;
      // The fit/scale decision comes from the always-measurable off-screen probe
      // (see computeCanonicalFit), so this works correctly even while the card
      // modal itself is still `hidden` (display: none) during opening.
      const result = computeCanonicalFit(state.message);
      applyMessageRender(cardModalMessageTargets, state.message, result.scale);
    }
  }

  function cycleCardModal(delta) {
    modalCardDesign = getAdjacentDesignId(modalCardDesign, delta);
    renderCardModalView(modalCardDesign);
  }

  function getFocusableInCardModal() {
    if (!cardModal) return [];
    return Array.from(cardModal.querySelectorAll('button')).filter((el) => el.offsetParent !== null);
  }

  function openCardModal(trigger) {
    if (!cardModal) return;
    modalCardDesign = state.cardDesign;
    renderCardModalView(modalCardDesign);
    cardModalTrigger = trigger || document.activeElement;
    cardModal.hidden = false;
    document.documentElement.classList.add('gp-scroll-locked');
    if (cardModalClose) cardModalClose.focus();
  }

  function closeCardModal() {
    if (!cardModal) return;
    cardModal.hidden = true;
    document.documentElement.classList.remove('gp-scroll-locked');
    if (cardModalTrigger && typeof cardModalTrigger.focus === 'function') cardModalTrigger.focus();
    cardModalTrigger = null;
  }

  function selectCardModalDesign() {
    state.cardDesign = modalCardDesign;
    renderCardDesign();
    persist();
    closeCardModal();
  }

  if (viewCardDesignsBtn) viewCardDesignsBtn.addEventListener('click', () => openCardModal(viewCardDesignsBtn));
  if (cardPreviewName) cardPreviewName.addEventListener('click', () => openCardModal(cardPreviewName));

  if (cardModalPrevBtn) cardModalPrevBtn.addEventListener('click', () => cycleCardModal(-1));
  if (cardModalNextBtn) cardModalNextBtn.addEventListener('click', () => cycleCardModal(1));
  if (cardModalSelectBtn) cardModalSelectBtn.addEventListener('click', selectCardModalDesign);
  if (cardModalClose) cardModalClose.addEventListener('click', closeCardModal);
  if (cardModalBackdrop) cardModalBackdrop.addEventListener('click', closeCardModal);

  cardModalDots.forEach((dot) => {
    dot.addEventListener('click', () => {
      modalCardDesign = dot.dataset.design;
      renderCardModalView(modalCardDesign);
    });
  });

  if (cardModal) {
    cardModal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeCardModal();
        return;
      }
      if (event.key === 'ArrowRight') { event.preventDefault(); cycleCardModal(1); return; }
      if (event.key === 'ArrowLeft') { event.preventDefault(); cycleCardModal(-1); return; }

      if (event.key === 'Tab') {
        const focusable = getFocusableInCardModal();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  }

  if (cardModalCard) {
    const CARD_MODAL_SWIPE_THRESHOLD = 40;
    let modalDragStartX = null;
    let modalDragging = false;

    cardModalCard.addEventListener('pointerdown', (event) => {
      modalDragStartX = event.clientX;
      modalDragging = true;
    });

    cardModalCard.addEventListener('pointerup', (event) => {
      if (!modalDragging || modalDragStartX === null) return;
      modalDragging = false;
      const delta = event.clientX - modalDragStartX;
      if (Math.abs(delta) > CARD_MODAL_SWIPE_THRESHOLD) cycleCardModal(delta < 0 ? 1 : -1);
      modalDragStartX = null;
    });

    cardModalCard.addEventListener('pointercancel', () => {
      modalDragging = false;
      modalDragStartX = null;
    });
  }

  function updateFieldCounter(key) {
    const field = msgFields[key];
    if (!field || !field.el || !field.counter) return;
    field.counter.textContent = `${field.el.value.length} / ${field.max} characters`;
  }

  function currentModalMessageValues() {
    return {
      to: msgFields.to.el ? msgFields.to.el.value : '',
      body: msgFields.body.el ? msgFields.body.el.value : '',
      signoff: msgFields.signoff.el ? msgFields.signoff.el.value : '',
    };
  }

  function updateMessageValidation(liveValues, fits) {
    const bodyOk = isBodyLongEnough(liveValues.body);
    if (msgFields.body.warning) msgFields.body.warning.hidden = bodyOk;
    if (messageModalOverflowWarning) messageModalOverflowWarning.hidden = fits;
    if (messageModalSave) messageModalSave.disabled = !(bodyOk && fits);
  }

  function previewMessageLive() {
    const liveValues = currentModalMessageValues();
    const result = computeCanonicalFit(liveValues);
    lastMessageFits = result.fits;
    applyMessageRender(gpMessageTargets, liveValues, result.scale);
    updateMessageValidation(liveValues, result.fits);
  }

  function openMessageModal() {
    if (!messageModal) return;
    Object.entries(msgFields).forEach(([key, field]) => {
      if (field.el) field.el.value = state.message[key];
      updateFieldCounter(key);
    });
    previewMessageLive();
    messageModal.hidden = false;
    if (msgFields.to.el) msgFields.to.el.focus();
  }

  function closeMessageModal() {
    if (!messageModal) return;
    messageModal.hidden = true;
    renderMessage();
    if (editMessageBtn) editMessageBtn.focus();
  }

  function saveMessage() {
    const liveValues = currentModalMessageValues();
    state.message = {
      to: liveValues.to.trim(),
      body: liveValues.body.trim(),
      signoff: liveValues.signoff.trim(),
    };
    renderMessage();
    persist();
    closeMessageModal();
  }

  if (editMessageBtn) editMessageBtn.addEventListener('click', openMessageModal);
  Object.entries(msgFields).forEach(([key, field]) => {
    if (!field.el) return;
    field.el.addEventListener('input', () => {
      updateFieldCounter(key);
      previewMessageLive();
    });
  });
  if (messageModalCancel) messageModalCancel.addEventListener('click', closeMessageModal);
  if (messageModalBackdrop) messageModalBackdrop.addEventListener('click', closeMessageModal);
  if (messageModalSave) messageModalSave.addEventListener('click', saveMessage);

  if (messageModal) {
    messageModal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMessageModal();
    });
  }

  // ---- Checkout: real Shopify variant, added to cart with personalisation as line-item properties ----
  function buildCheckoutIntent() {
    const design = CARD_DESIGNS.find((d) => d.id === state.cardDesign);
    const variantsForDesign = CARD_DESIGN_VARIANT_ID[state.cardDesign];
    return {
      necklaceVariantId: variantsForDesign ? variantsForDesign[state.finish][state.box] : null,
      properties: {
        'Card Design': design ? design.name : '',
        'Necklace Finish': state.finish === 'silver' ? 'White Gold Finish' : 'Gold',
        'Gift Box': BOX_OPTIONS[state.box].label,
        'Personal Message': composePersonalMessage(state.message),
      },
    };
  }

  async function handleCheckout() {
    const intent = buildCheckoutIntent();
    if (!intent.necklaceVariantId) return;

    const properties = {};
    Object.entries(intent.properties).forEach(([key, value]) => {
      if (value) properties[key] = value;
    });

    checkoutButtons.forEach((button) => { button.disabled = true; });

    try {
      // Clear any existing cart contents first so the cart never carries a
      // stale line item from an earlier visit or an earlier configuration —
      // checkout should only ever contain the one necklace configured here.
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(intent.necklaceVariantId),
              quantity: 1,
              properties: properties,
            },
          ],
        }),
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => null);
        throw new Error((errorBody && errorBody.description) || 'Unable to add item to cart.');
      }

      window.location.href = '/checkout';
    } catch (error) {
      checkoutButtons.forEach((button) => { button.disabled = false; });
      window.alert('Something went wrong adding your gift to the cart. Please try again.');
    }
  }

  checkoutButtons.forEach((button) => button.addEventListener('click', handleCheckout));
}

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zaviqu-homepage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
const heroVideo = document.getElementById('heroVideo');

if (heroVideo) {
  heroVideo.muted = true;
  heroVideo.defaultMuted = true;
  heroVideo.setAttribute('muted', '');
  heroVideo.removeAttribute('controls');

  const attemptHeroPlay = () => {
    const playPromise = heroVideo.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  };

  attemptHeroPlay();
  heroVideo.addEventListener('loadedmetadata', attemptHeroPlay);
  heroVideo.addEventListener('canplay', attemptHeroPlay);
  heroVideo.addEventListener('canplaythrough', attemptHeroPlay);

  const resumeHeroOnInteraction = () => {
    attemptHeroPlay();
  };
  ['touchstart', 'click', 'scroll', 'keydown', 'pointerdown'].forEach((evt) => {
    document.addEventListener(evt, resumeHeroOnInteraction, { passive: true });
  });

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') attemptHeroPlay();
  });

  window.addEventListener('pageshow', attemptHeroPlay);
}

const storySection = document.getElementById('storySection');
const storyVideo = document.getElementById('storyVideo');

if (storySection && storyVideo) {
  const storyInner = storySection.querySelector('.story__inner');

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          storyInner.classList.add('is-visible');
          revealObserver.unobserve(storySection);
        }
      });
    },
    { threshold: 0.2 }
  );
  revealObserver.observe(storySection);

  const playbackObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          storyVideo.play().catch(() => {});
        } else {
          storyVideo.pause();
        }
      });
    },
    { threshold: 0.4 }
  );
  playbackObserver.observe(storyVideo);

  const showControls = () => storyVideo.setAttribute('controls', '');
  const hideControls = () => storyVideo.removeAttribute('controls');
  storyVideo.addEventListener('mouseenter', showControls);
  storyVideo.addEventListener('mouseleave', hideControls);
  storyVideo.addEventListener('focus', showControls);
  storyVideo.addEventListener('blur', hideControls);
}

const hiwSection = document.getElementById('hiwSection');
const hiwFrames = document.querySelectorAll('.hiw__frame');
const hiwSteps = document.querySelectorAll('.hiw__step');
const hiwDots = document.querySelectorAll('.hiw__dot');
const hiwPrevBtn = document.getElementById('hiwPrevBtn');
const hiwNextBtn = document.getElementById('hiwNextBtn');

if (hiwSection && hiwFrames.length) {
  const STEP_COUNT = hiwFrames.length;
  const AUTOPLAY_MS = 4000;
  const hiwPrefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let currentStep = 0;
  let autoplayTimer = null;
  let isPaused = false;
  let isInView = false;

  function setStep(index) {
    currentStep = ((index % STEP_COUNT) + STEP_COUNT) % STEP_COUNT;

    hiwFrames.forEach((frame) => {
      const isActive = Number(frame.dataset.step) === currentStep;
      frame.classList.toggle('is-active', isActive);
      frame.setAttribute('aria-hidden', String(!isActive));
    });
    hiwSteps.forEach((step) => {
      const isActive = Number(step.dataset.step) === currentStep;
      step.classList.toggle('is-active', isActive);
      step.setAttribute('aria-hidden', String(!isActive));
    });
    hiwDots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === currentStep);
      dot.setAttribute('aria-selected', String(i === currentStep));
    });
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function startAutoplay() {
    if (hiwPrefersReducedMotion || isPaused || !isInView) return;
    stopAutoplay();
    autoplayTimer = window.setInterval(() => setStep(currentStep + 1), AUTOPLAY_MS);
  }

  function goToStep(index) {
    setStep(index);
    stopAutoplay();
    startAutoplay();
  }

  hiwDots.forEach((dot) => {
    dot.addEventListener('click', () => goToStep(Number(dot.dataset.step)));
  });
  if (hiwPrevBtn) hiwPrevBtn.addEventListener('click', () => goToStep(currentStep - 1));
  if (hiwNextBtn) hiwNextBtn.addEventListener('click', () => goToStep(currentStep + 1));

  hiwSection.addEventListener('mouseenter', () => { isPaused = true; stopAutoplay(); });
  hiwSection.addEventListener('mouseleave', () => { isPaused = false; startAutoplay(); });
  hiwSection.addEventListener('touchstart', () => { isPaused = true; stopAutoplay(); }, { passive: true });
  hiwSection.addEventListener('focusin', () => { isPaused = true; stopAutoplay(); });
  hiwSection.addEventListener('focusout', () => { isPaused = false; startAutoplay(); });

  if (!hiwPrefersReducedMotion) {
    const hiwObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          isInView = entry.isIntersecting;
          if (isInView) startAutoplay();
          else stopAutoplay();
        });
      },
      { threshold: 0.4 }
    );
    hiwObserver.observe(hiwSection);
  }

  setStep(0);
}

const configureSection = document.getElementById('configureSection');

if (configureSection) {
  const finishOptions = configureSection.querySelectorAll('.finish-option');
  const finishImages = configureSection.querySelectorAll('.configure__image');
  const messageToField = document.getElementById('giftMessageTo');
  const messageToCount = document.getElementById('giftMessageToCount');
  const messageField = document.getElementById('giftMessage');
  const messageCount = document.getElementById('giftMessageCount');
  const messageSignoffField = document.getElementById('giftMessageSignoff');
  const messageSignoffCount = document.getElementById('giftMessageSignoffCount');
  const messagePreviewText = document.getElementById('messagePreviewText');
  const previewBtn = document.getElementById('previewGiftBtn');
  const MESSAGE_PLACEHOLDER = 'Your message will appear here…';

  let selectedFinish = 'gold';

  let restoredConfig = {};
  try {
    const raw = sessionStorage.getItem('zaviquGiftConfig');
    if (raw) restoredConfig = JSON.parse(raw);
  } catch (e) {
    // Malformed or missing config — start from the gold/blank defaults below.
  }

  // Mirrors normalizeStoredMessage() in zaviqu-gift-preview.liquid so the two
  // pages read/write the exact same { to, body, signoff } shape.
  function normalizeMessage(rawMessage) {
    if (rawMessage && typeof rawMessage === 'object') {
      return {
        to: typeof rawMessage.to === 'string' ? rawMessage.to : '',
        body: typeof rawMessage.body === 'string' ? rawMessage.body : '',
        signoff: typeof rawMessage.signoff === 'string' ? rawMessage.signoff : '',
      };
    }
    if (typeof rawMessage === 'string') {
      // Legacy single-field format from before the three-field redesign.
      return { to: '', body: rawMessage, signoff: '' };
    }
    return { to: '', body: '', signoff: '' };
  }

  function selectFinish(finish) {
    selectedFinish = finish;

    finishOptions.forEach((option) => {
      const isMatch = option.dataset.finish === finish;
      option.classList.toggle('is-selected', isMatch);
      option.setAttribute('aria-checked', String(isMatch));
    });

    finishImages.forEach((image) => {
      image.classList.toggle('is-active', image.dataset.image === finish);
    });
  }

  finishOptions.forEach((option) => {
    option.addEventListener('click', () => selectFinish(option.dataset.finish));
  });

  function updateMessagePreview() {
    const parts = [
      messageToField ? messageToField.value.trim() : '',
      messageField ? messageField.value.trim() : '',
      messageSignoffField ? messageSignoffField.value.trim() : '',
    ].filter(Boolean);
    const value = parts.join('\n\n');
    if (messagePreviewText) {
      messagePreviewText.textContent = value || MESSAGE_PLACEHOLDER;
      messagePreviewText.classList.toggle('is-placeholder', !value);
    }
  }

  if (restoredConfig.finish === 'silver') selectFinish('silver');

  const restoredMessage = normalizeMessage(restoredConfig.message);
  if (messageToField) messageToField.value = restoredMessage.to;
  if (messageField) messageField.value = restoredMessage.body;
  if (messageSignoffField) messageSignoffField.value = restoredMessage.signoff;

  function wireCounter(field, counter) {
    if (!field || !counter) return;
    const max = Number(field.getAttribute('maxlength'));
    const updateCount = () => {
      counter.textContent = `${field.value.length} / ${max} characters`;
    };
    field.addEventListener('input', () => {
      updateCount();
      updateMessagePreview();
    });
    updateCount();
  }

  wireCounter(messageToField, messageToCount);
  wireCounter(messageField, messageCount);
  wireCounter(messageSignoffField, messageSignoffCount);
  updateMessagePreview();

  if (previewBtn) {
    previewBtn.addEventListener('click', () => {
      let existing = {};
      try {
        const raw = sessionStorage.getItem('zaviquGiftConfig');
        if (raw) existing = JSON.parse(raw);
      } catch (e) {
        // Malformed existing config — proceed with just the fields set below.
      }
      const config = {
        ...existing,
        finish: selectedFinish,
        message: {
          to: messageToField ? messageToField.value.trim() : '',
          body: messageField ? messageField.value.trim() : '',
          signoff: messageSignoffField ? messageSignoffField.value.trim() : '',
        },
      };
      sessionStorage.setItem('zaviquGiftConfig', JSON.stringify(config));
    });
  }
}

const revealEls = document.querySelectorAll('.reveal');

if (revealEls.length) {
  const genericRevealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          genericRevealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  revealEls.forEach((el) => genericRevealObserver.observe(el));
}

document.querySelectorAll('.faq-item__question').forEach((button) => {
  button.addEventListener('click', () => {
    const item = button.closest('.faq-item');
    const wasOpen = item.classList.contains('is-open');

    document.querySelectorAll('.faq-item.is-open').forEach((openItem) => {
      openItem.classList.remove('is-open');
      openItem.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
    });

    if (!wasOpen) {
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
    }
  });
});

});

  } catch(e) { console.error(e); }
})();
})();
